import * as React from 'react'

import { FlexProps } from '@dna/react-types'
import { Flex } from '../flex'

/**
 * If you need to lay out content horizontally, use ‘Columns’ and ‘Column’ components.
 *
 * @name
 * Columns
 *
 * @see
 * https://dna.telstrahealth.com/components/columns
 *
 * @example
 * <Columns css={{gap: 'medium'}}>
 */
export function Columns(props: FlexProps) {
  let { children, css: styleProps = {}, ...otherProps } = props

  return (
    // @ts-ignore
    <Flex css={{ flexDirection: 'row', ...styleProps }} {...otherProps}>
      {children}
    </Flex>
  )
}
